import { useDispatch, useSelector } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";
import ErrorBoundaryWithLogging from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging/ErrorBoundaryWithLogging";
import ListPreLoaderItem from "app/pages/sales-intelligence/common-components/ListPreLoaderItem/ListPreLoaderItem";
import ListNotFoundModalContainer from "app/pages/sales-intelligence/common-components/modals/ListNotFoundModal/ListNotFoundModalContainer";
import ScrollToTopWrapper from "app/pages/sales-intelligence/common-components/ScrollToTopWrapper/ScrollToTopWrapper";
import { STATIC_LIST_PAGE_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import withSecondaryBarSet from "app/pages/sales-intelligence/hoc/withSecondaryBarSet";
import { PAGE_SIZE } from "app/pages/sales-intelligence/modules/lists/constants/constants";
import CRMListsContainer from "app/pages/sales-intelligence/modules/lists/sub-modules/crm-list/containers/CRMListsContainer/CRMListsContainer";
import { CrmIntegrationContainer } from "app/pages/sales-intelligence/modules/lists/sub-modules/crm-list/containers/CRMListsSection/CrmIntegrationContainer";
import useCRMList from "app/pages/sales-intelligence/modules/lists/sub-modules/crm-list/queries/useCRMList";
import ListPageHeader from "app/pages/sales-intelligence/pages/lists/components/common/ListPageHeader/ListPageHeader";
import ListSectionLoaders from "app/pages/sales-intelligence/pages/lists/components/common/ListsSection/ListSectionLoaders";
import {
    ListsPageInnerContainer,
    StyledListsPageContainer,
} from "app/pages/sales-intelligence/pages/lists/components/common/styles";
import CrmListErrorState from "app/pages/sales-intelligence/pages/lists/components/crm-lists/CrmListErrorState/CrmListErrorState";
import { StyledCRMListContainerWrapper } from "app/pages/sales-intelligence/pages/lists/containers/styles";
import { fetchWorkspacesThunk } from "app/pages/sales-intelligence/sub-modules/common/store/effects";
import { fetchCrmListsThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/crmLists";
import { getHubspotStatusThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/hubspot/status";
import { getSalesforceStatusThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/salesforce/status";
import ListModalContainer from "app/pages/sales-intelligence/sub-modules/opportunities/containers/ListModal/ListModalContainer";
import {
    selectIsLoadingListsPage,

} from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const CrmListsPageContainer = () => {
    const dispatch = useDispatch();
    const { data, isLoading, setPage, refetch } = useCRMList({ initialPage: 1, pageSize: PAGE_SIZE });

    useMount(() => {
        dispatch(fetchWorkspacesThunk());
        dispatch(getHubspotStatusThunk());
        dispatch(getSalesforceStatusThunk());
        dispatch(fetchCrmListsThunk());
    });

    const isLoadingListPage = useSelector(selectIsLoadingListsPage);

    const handleListCreate = (listId: string): void => {
        proNavigator.go(STATIC_LIST_PAGE_ROUTE, {
            id: listId,
        });
    };

    const renderContent = () => {
        if (isLoadingListPage) {return <ListSectionLoaders />;}

        return <CrmIntegrationContainer hasTitle={false} />;
    };

    return (
        <ScrollToTopWrapper>
            <ErrorBoundaryWithLogging fallback={<CrmListErrorState />}>
                <StyledListsPageContainer>
                    <ListsPageInnerContainer>
                        <ListNotFoundModalContainer />
                        <ListModalContainer onListCreate={handleListCreate} />
                        <ListPageHeader
                            title={{ key: "si.pages.crm_lists.title" }}
                            description={{ key: "si.pages.crm_lists.description" }}
                        />
                        {isLoading || (data && data.records.length) ? (
                            <StyledCRMListContainerWrapper>
                                {isLoading ? <ListPreLoaderItem rowNumber={3} /> : null}
                                {!isLoading && data ? <CRMListsContainer records={data.records} /> : null}
                            </StyledCRMListContainerWrapper>
                        ) : null}

                        {renderContent()}
                    </ListsPageInnerContainer>
                </StyledListsPageContainer>
            </ErrorBoundaryWithLogging>
        </ScrollToTopWrapper>
    );
};

export default withSecondaryBarSet("SalesIntelligenceLists")(CrmListsPageContainer);
